import { styled } from '@withjoy/joykit/theme';
import { animationTransition } from '../../utils/animationTransitions';
import { animated } from 'react-spring';
import type { SegmentedControllerVariant } from './SegmentedController.types';

export const ItemsWrapper = styled.div<Readonly<{ variant?: SegmentedControllerVariant }>>`
  min-height: ${({ variant }) => (variant === 'underline' ? '48px' : '44px')};
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: ${({ variant }) => (variant === 'underline' ? '0' : '4px')};
  position: relative;
  z-index: 1;
  width: 100%;
`;

/**
 * `hasDescriptions` is a transient prop: it exists only to pick the shadow/radius step below and
 * must not leak to the DOM as an attribute. Two-line description items (see ToggleItem) need the
 * stronger pill to read against their taller cell; every other pill `SegmentedController` in the
 * app keeps the original Joy chrome.
 */
export const PillIndicator = styled(animated.span).withConfig<Readonly<{ hasDescriptions?: boolean }>>({ shouldForwardProp: prop => prop !== 'hasDescriptions' })`
  position: absolute;
  bottom: 0;
  height: calc(100% - 8px);
  transition: ${animationTransition('background-color')};
  left: 0;
  width: 0;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ hasDescriptions }) => (hasDescriptions ? '0px 1px 3px 0px rgba(0, 0, 0, 0.08)' : '0px 1px 2px 0px rgba(0, 0, 0, 0.05)')};
  border-radius: ${({ hasDescriptions }) => (hasDescriptions ? '9px' : '8px')};
  z-index: 0;
  top: 50%;
`;

export const UnderlineIndicator = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 0;
  background-color: ${({ theme }) => theme.colors.mono14};
  border-radius: 2px;
  transition: ${animationTransition('transform', 'width', { duration: '300ms', timingFunction: 'ease' })};
  pointer-events: none;
`;

export const SegmentedControllerRoot = styled.div<Readonly<{ width?: string; isMobile?: boolean; variant?: SegmentedControllerVariant }>>`
  width: ${({ width, isMobile }) => (width && !isMobile ? width : isMobile ? '100%' : 'initial')};
  position: relative;
  background: ${({ variant, theme }) => (variant === 'underline' ? 'transparent' : theme.colors.mono2)};
  border-radius: ${({ variant }) => (variant === 'underline' ? '0' : '12px')};
  ${({ variant, theme }) => (variant === 'underline' ? `border-bottom: 1px solid ${theme.colors.mono3};` : '')}
`;
